import LastSessionInformer from './LastSessionInformer';
export default LastSessionInformer;
